module.exports = __webpack_public_path__ + "static/pdf/Animesh_Manglik_Resume_2017.fd9dbc1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Animesh_Manglik_Resume_2017.pdf
// module id = 34
// module chunks = 0